<template>
  <Modal
    v-model="visible"
    :mask-closable="false"
    :footer-hide="true"
    width="700"
    class-name="apply-invoice-modal"
    @on-visible-change="onVisibleChange"
  >
    <div class="modal-header">
      <span class="modal-title">{{ isBatch ? '批量申请开票' : '申请开票' }}</span>
    </div>

    <div class="modal-body">
      <!-- 开票明细 -->
      <div class="section">
        <div class="section-title">开票明细</div>
        <div class="detail-table-wrap">
          <table class="detail-table">
            <colgroup>
              <col style="width: 180px" />
              <col style="width: 120px" />
              <col style="width: 100px" />
              <col style="width: 120px" />
            </colgroup>
            <thead>
              <tr>
                <th>开票订单</th>
                <th>收益类型</th>
                <th>账期</th>
                <th>开票金额</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in detailList" :key="idx">
                <td>{{ item.order_no }}</td>
                <td>{{ typeText(item.type) }}</td>
                <td>{{ item.period }}</td>
                <td>¥{{ item.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 批量汇总 -->
        <div v-if="isBatch" class="batch-summary">
          <span>已选{{ detailList.length }}条</span>
          <span class="total">合计开票金额：<span class="amount">¥{{ totalAmount }}</span></span>
        </div>
      </div>

      <!-- 开票信息 -->
      <div class="section">
        <div class="section-title-bar">
          <span class="section-title">开票信息</span>
          <span class="edit-link" @click="onEditTitle">编辑信息</span>
        </div>

        <!-- 个人 -->
        <div v-if="titleData.type === 0" class="title-info personal">
          <div class="info-row">
            <span class="info-label">抬头类型：</span>
            <span class="info-value">个人</span>
          </div>
          <div class="info-row">
            <span class="info-label">发票抬头：</span>
            <span class="info-value">{{ titleData.title || '-' }}</span>
          </div>
        </div>

        <!-- 企业 -->
        <div v-else class="title-info enterprise">
          <div class="info-row">
            <span class="info-label">抬头类型：</span>
            <span class="info-value">企业</span>
          </div>
          <div class="info-row">
            <span class="info-label">发票抬头：</span>
            <span class="info-value">{{ titleData.title || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">税号：</span>
            <span class="info-value">{{ titleData.tax_number || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">开户银行：</span>
            <span class="info-value">{{ titleData.bank_name || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">银行账号：</span>
            <span class="info-value">{{ titleData.bank_account || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">企业电话：</span>
            <span class="info-value">{{ titleData.phone || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">企业地址：</span>
            <span class="info-value">{{ titleData.company_address || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 发票类型 -->
      <div class="section form-section">
        <div class="form-row">
          <span class="form-label required">发票类型</span>
          <RadioGroup v-model="form.invoice_type">
            <Radio label="normal">
              <span>电子普通发票</span>
            </Radio>
            <Radio label="special" :disabled="titleData.type === 0">
              <span>电子专用发票</span>
            </Radio>
          </RadioGroup>
          <span v-if="titleData.type === 0" class="form-sublabel">（个人仅可开具增值税普通发票）</span>
        </div>
      </div>

      <!-- 接收发票邮箱 -->
      <div class="section form-section">
        <div class="form-row">
          <span class="form-label required">接收发票邮箱</span>
          <span class="form-sublabel">（开票成功后电子发票PDF文件将自动推送至该邮箱）</span>
        </div>
        <Input
            class="email-input"
          v-model="form.email"
          placeholder="请输入电子邮箱（必填），可到开票信息中设置默认收票邮箱号"
        />
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="modal-footer">
      <div class="btn cancel" @click="onCancel">取消</div>
      <div class="btn confirm" @click="onConfirm">提交申请</div>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'ApplyInvoiceModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
    titleData: {
      type: Object,
      default: () => ({
        type: 0,
        title: '',
        tax_number: '',
        company_address: '',
        phone: '',
        bank_name: '',
        bank_account: '',
        send_mail: '',
        tax_type: 0,
      }),
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        invoice_type: 'normal',
        email: '',
      },
    }
  },
  computed: {
    detailList() {
      return this.items && this.items.length ? this.items : []
    },
    totalAmount() {
      return this.detailList
        .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
        .toFixed(2)
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = {
          invoice_type: 'normal',
          email: this.titleData.send_mail || '',
        }
      }
    },
  },
  methods: {
    onVisibleChange(val) {
      this.$emit('update:visible', val)
    },
    typeText(type) {
      return type == 1 ? '商城订单结算' : '其他'
    },
    onEditTitle() {
      this.$emit('edit-title')
    },
    onCancel() {
      this.$emit('update:visible', false)
    },
    onConfirm() {
      if (!this.form.email) {
        this.$Message.warning('请输入接收发票邮箱')
        return
      }
      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailReg.test(this.form.email)) {
        this.$Message.warning('请输入正确的邮箱格式')
        return
      }
      this.$emit('confirm', {
        items: this.detailList,
        invoice_type: this.form.invoice_type,
        email: this.form.email,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .apply-invoice-modal {
  text-align: left;
  .ivu-modal-content {
    border-radius: 8px;
  }
  .ivu-modal-body {
    padding: 0;
  }
  .ivu-modal-close {
    top: 16px;
    right: 16px;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;

  .modal-title {
    font-size: 16px;
    font-weight: bold;
    color: #1a1a1a;
  }
}

.modal-body {
  padding: 24px;
  max-height: 60vh;
  overflow-y: auto;

  .section {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      font-size: 14px;
      font-weight: bold;
      color: #1a1a1a;
      margin-bottom: 12px;
    }

    .section-title-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      .section-title {
        margin-bottom: 0;
      }

      .edit-link {
        font-size: 13px;
        color: #0d99ff;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .detail-table-wrap {
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    overflow: hidden;

    .detail-table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;

      thead {
        background: #f6f7fa;

        th {
          padding: 10px 12px;
          font-size: 13px;
          color: #666666;
          font-weight: normal;
          text-align: left;
        }
      }

      tbody {
        tr {
          border-top: 1px solid #f0f0f0;

          td {
            padding: 12px;
            font-size: 13px;
            color: #333333;
          }
        }
      }
    }
  }

  .batch-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;
    font-size: 13px;
    color: #666666;

    .total {
      .amount {
        color: #ff5967;
        font-weight: bold;
      }
    }
  }

  .title-info {
    .info-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 10px;
      font-size: 13px;

      &:last-child {
        margin-bottom: 0;
      }

      .info-label {
        color: #666666;
        width: 80px;
        flex-shrink: 0;
      }

      .info-value {
        color: #333333;
        flex: 1;
      }
    }

    &.enterprise {
      display: flex;
      flex-wrap: wrap;
      gap: 10px 0;

      .info-row {
        width: 50%;
        margin-bottom: 0;

        .info-label {
          width: 70px;
        }
      }
    }
  }

  .form-section {
    .form-row {
        display: flex;
        align-items: center;
        gap: 4px;
      .form-label {
        font-size: 13px;
        color: #333333;
        display: inline-block;
        flex-shrink: 0;

        &.required::after {
          content: '*';
          color: #ff5967;
          margin-left: 4px;
        }
      }

      .form-sublabel {
        font-size: 12px;
        color: #999999;
        margin-left: 4px;
      }
    }
    .email-input {
        margin-top: 12px;
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px 24px 24px;

  .btn {
    min-width: 120px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    padding: 0 20px;

    &.cancel {
      background: #ffffff;
      border: 1px solid #e3e3e3;
      color: #999999;
    }

    &.confirm {
      background: #ff5967;
      color: #ffffff;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}

/* 覆盖选中时的背景色和边框色 */
/* 1. 覆盖选中状态的外层边框和背景 */
::v-deep   .ivu-radio-checked .ivu-radio-inner {
    border-color: #FF5967 !important;
}

/* 2. ⚠️ 核心：覆盖内部圆点的颜色（伪元素 ::after） */
::v-deep   .ivu-radio-checked .ivu-radio-inner::after {
    background-color: #FF5967 !important; /* 将圆点改为你想要的颜色 */
}
</style>
